import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Alert, Checkbox, Button, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type PhoneCheckrModalProps = {
  onCancel: () => void
  onConfirm: (value: boolean) => void
}

export const PhoneCheckrModal = observer(({ onCancel, onConfirm }: PhoneCheckrModalProps) => {
  const [checked, setChecked] = useState(false)

  return (
    <div className={styles.root}>
      <div className={styles.notification}>
        <Alert
          item={{
            type: 'infoLight',
            title: 'Validate phone types instantly',
            desc: 'PhoneCheckr will lookup your phone numbers and determine the phone type: voip, landline, mobile, null.',
          }}
          marginBottom={32}
        />
        <label className={styles.wrapPlaceholder} htmlFor={'lookupAllContacts'}>
          <Checkbox
            id={'lookupAllContacts'}
            checked={checked}
            onChange={() => setChecked(!checked)}
            size={16}
          />
          <Typography
            variant={'text-input-field'}
            color={'tertiary'}
            ariaLabel={'Lookup all existing contacts'}
            style={{ cursor: 'pointer' }}
          >
            Lookup all existing contacts
          </Typography>
        </label>
      </div>

      <div className={styles.actions}>
        <Button
          typeBtn={'contained'}
          text={'Cancel'}
          size={'medium'}
          contained={'secondary'}
          textClassname={styles.button}
          onClick={onCancel}
        />
        <Button
          typeBtn={'contained'}
          text={'Confirm'}
          size={'medium'}
          textClassname={styles.button}
          onClick={() => onConfirm(checked)}
        />
      </div>
    </div>
  )
})
